import { GridContainerParams } from './GridContainers.props';
import { WraperContainer } from './styles';

export const GridContainer = ({ children, ...props }: GridContainerParams) => {
    return <WraperContainer {...props}>{children}</WraperContainer>;
};
